import clsx from "clsx";

const ThemedText = ({
    children,
    variant = "default",
    size = "md",
    className,
    as: Component = "p",
    ...props
}) => {
    const variants = {
        default: "text-zinc-900 dark:text-zinc-100",
        secondary: "text-zinc-500 dark:text-zinc-400",
        caption: "text-zinc-400 dark:text-zinc-500",
        primary: "text-primary-500 dark:text-primary-400",
        danger: "text-danger-500 dark:text-danger-400",
        success: "text-success-500 dark:text-success-400",
        warning: "text-warning-500 dark:text-warning-400",
        white: "text-white",
    };

    const sizes = {
        xxs: "text-[10px]",
        xs: "text-xs",
        sm: "text-sm",
        md: "text-base",
        lg: "text-lg",
        xl: "text-xl",
        "2xl": "text-2xl",
        "3xl": "text-3xl",
    };

    return (
        <Component
            className={clsx(variants[variant], sizes[size], className)}
            {...props}
        >
            {children}
        </Component>
    );
};

export default ThemedText;
